<template>
    <div class="container">
        <div v-if="isApp&&routeName==='/home/homePage'">
            <div class="title acctit homelc">
                {{$t('logo')}}
                <div class="addbtn btnn">
                    <el-popover
                            placement="bottom"
                            width="80"
                            trigger="click">
                        <div class="lanlist">
                            <div :class="lang==item.name?'activeList':''" @click="changlang(item.name, item)" v-for="(item, index) in langList" :key="index">
                                <img :src="item.flag"/>{{item.full_name}}
                            </div>
                        </div>
                        <div slot="reference"><img :src="currentLang.flag"/>{{currentLang.full_name}}</div>
                    </el-popover>
                </div>
            </div>
        </div>
        <div class="banner" v-if="!isApp||(isApp&&(routeName==='/home/homePage'))">
            <el-carousel indicator-position="inside">
                <el-carousel-item v-for="(item, index) in lists" :key="index">
                    <img class="bannerimg" :src="item.image">
                </el-carousel-item>
            </el-carousel>
        </div>
        <div class="contenbg">
          <router-view></router-view>
        </div>
    </div>
</template>

<script>
    // @ is an alias to /src
    import Cookies from 'js-cookie'
    import {getSlideList} from '@/api/index'

    export default {
        name: 'HomeView',
        components: {},
        computed: {
            isApp() {
                return document.documentElement.clientWidth < 800 ? true : false
            },
            routeName() {
                console.log(this.$route.path)
                return this.$route.path
            }

        },
        data() {
            return {
                lists: [],
                lang: Cookies.get('lang'),
                langList: [],
                currentLang: {},

            }
        },
        mounted() {
            console.log(!this.isApp || (this.isApp && this.routeName === '/home/homePage'))
        },
        created() {
            this.getData()
        },
        methods: {
            changlang(lang, item) {
                if(lang != this.lang){
                    this.lang = lang
                    this.currentLang = item
                    this.$i18n.locale = lang
                    Cookies.set('lang', lang)
                    Cookies.set('lang_var', item.lang_var)
                    this.$router.go(0)
                }
            },
            getData() {
                getSlideList().then(res => {
                    console.log(res)
                    const data = res.data
                    this.lists = data.lists
                    this.langList = res.data.langList
                    if(this.langList){
                        for(let index = 0; index < this.langList.length; index++){
                            let item = this.langList[index]
                            if(this.lang == item.name){
                                this.currentLang = item
                                break
                            }
                        }
                    }
                }).catch(_ => {

                })
            }
        }
    }
</script>
<style lang="scss" scoped>
.contenbg{
  background: url('../assets/imgs/homebg.jpeg') no-repeat;
  background-size: 100% 100%;
  padding: 20px 0px;
}
    .contenbox {
        width: 1200px;
        margin: 20px auto;
    }

    .homelc.acctit {
        color: #fff;
        line-height: 40px;
        max-height: 40px;
        overflow: hidden;
        // border-bottom: 1px solid #3a3a3a;
        .addbtn {
            position: absolute;
            right: 0px !important;
            top: 5px !important;
            background: #000  !important;
            font-size: 14px !important;
            border-radius: 4px !important;
            line-height: 26px !important;
            color: rgb(235 238 249) !important;
            padding: 2px 8px !important;

            img {
                width: 30px;
                height: 20px;
                vertical-align: middle;
                margin-right: 6px;
            }
        }
    }

    .sylistbox {
        .tablet {
            width: 100%;
            background: #3a3a3a;

            & > div {
                width: 33.2%;
                height: 50px;
                border: 1px solid #5c5c5c;
                line-height: 50px;
                font-size: 18px;

            }

            &.itemvue {
                border: 0px;
                background: #fff;

                & > div {
                    border: 0px;
                    color: #000;
                }

            }
        }

        .srollbox {
            height: 400px;
            background: #fff;
            overflow: hidden;
        }
    }

    .mkbox {
        color: #fff;
        padding: 20px 0px;

        .boxtit {
            color: rgb(65, 141, 241);
            font-size: 22px;
            text-align: left;
            font-weight: bolder;
            line-height: 60px;

            img {
                width: 40px;
                vertical-align: middle;

            }
        }

        .itembox {
            padding: 20px;
            box-sizing: border-box;
            border-radius: 10px;
            background: rgb(36, 36, 36);
            color: #fff;
            line-height: 50px;
            font-size: 30px;
            text-align: left;

            img {
                padding: 0px 20px 20px 0px;
                width: 100px;
                height: 100px;
            }

            &.hqitem {
                padding: 0px;
                overflow: hidden;
            }

            .titbar {
                -ms-flex-align: center;
                padding: 10px 20px;

                img {
                    width: 50px;
                    height: 50px;
                    border-radius: 100%;
                    vertical-align: middle;
                }

                .fonwbig {
                    vertical-align: middle;
                }

            }

            .hqbox {
                background: #fff;
                padding: 20px;
                box-sizing: border-box;
            }
        }

        .fonwbig {
            font-size: 40px;
            line-height: 60px;
        }
    }

    .bannerimg {
        width: 100%;
        height: 100%;

    }
</style>
